import { CheckCircle } from "lucide-react";
import { Link } from "react-router-dom";

export default function ThankYou() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-100 via-white to-green-50 flex flex-col items-center justify-center text-center px-6">
      <CheckCircle className="text-green-500 mb-4" size={64} />
      <h1 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-2">
        Thank You!
      </h1>
      <p className="text-lg text-gray-600 max-w-md mb-6">
        We've received your message and will be in touch shortly.
      </p>
      <Link
        to="/"
        className="bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-6 rounded-lg transition"
      >
        Back to Home
      </Link>
    </div>
  );
}
